import fetch from './fetch';


const siteId = 169;
const basePolicyURL = `/assets/sites/${siteId}/policies`;
const baseCommonPagesURL = `/assets/common_pages/${siteId}`;
const defaultOptions = {
  method: 'GET',
  headers: {
    Accept: 'application/json',
  },
  credentials: 'same-origin',
};


const parseDocument = (text) => {
  const parser = new DOMParser();

  return parser.parseFromString(text, 'text/html');
};


const editDocument = (doc) => {
  if (!doc) throw new Error('Invalid Document');

  // remove h1
  const h1 = doc.querySelector('h1');
  if (h1) h1.parentNode.removeChild(h1);

  // add a class to the lists
  const markedList = doc.getElementsByTagName('ul');
  if (markedList) {
    [].slice.call(markedList).forEach((item) => {
      item.classList.add('dot-list');
    });
  }

  // add the wrapper to the table
  const table = doc.getElementsByTagName('table');
  if (table) {
    const tableWrapper = document.createElement('div');
    tableWrapper.classList.add('table-container');

    [].slice.call(table).forEach((item) => {
      item.classList.add('table');
      tableWrapper.innerHTML = item.outerHTML;
      item.parentNode.replaceChild(tableWrapper, item);
    });
  }

  // change links href
  const links = doc.getElementsByTagName('a');
  if (links) {
    [].slice.call(links).forEach((item) => {
      const linkHref = item.getAttribute('href');

      switch (linkHref) {
        case '/plagiarism-free_guarantee.html':
          item.setAttribute('href', '/plagiarism-free-guarantee.html');
          break;
        case '/frequently_asked_questions.html':
          item.setAttribute('href', '/frequently-asked-questions.html');
          break;
        case '/contact-us.html':
          item.setAttribute('href', '/about-us.html');
          break;
        case '/password_reminder.html':
          item.setAttribute('href', '/dashboard/authorization');
          break;
        default: break;
      }
    });
  }

  return doc.body.innerHTML;
};


const getModifyPolicy = (res) => {
  if (!res) throw new Error('Lost data');

  return res.map((item) => {
    if (!item.isArchived) {
      return {
        ...item,
        text: editDocument(parseDocument(item.text)),
      };
    }

    return item;
  });
};


export const getSitePolicies = (policyTypeId) => {
  const urlSegments = [
    basePolicyURL,
    `?policy_type_id=${policyTypeId}`,
  ].filter(Boolean);

  const url = `${urlSegments.join('')}`;
  const options = Object.assign({}, defaultOptions);

  return fetch(url, options)
    .then(response => response.json())
    .then(getModifyPolicy);
};


export const getSitePolicyVersionText = (policyItemId) => {
  const urlSegments = [
    basePolicyURL,
    policyItemId,
  ].filter(Boolean);

  const url = `${urlSegments.join('/')}`;
  const options = Object.assign({}, defaultOptions);

  return fetch(url, options)
    .then(response => response.json())
    .then(json => json.text)
    .then(parseDocument)
    .then(editDocument);
};


export const getCommonPageText = (pageType) => {
  const urlSegments = [
    baseCommonPagesURL,
    pageType,
  ].filter(Boolean);

  const url = `${urlSegments.join('/')}`;
  const options = Object.assign({}, defaultOptions);

  return fetch(url, options)
    .then(response => response.json())
    .then(json => json.html)
    .then(parseDocument)
    .then(editDocument);
};
